// 감사 로그 표시용 메타 — 필드명 한글 라벨과 값 포매팅.
//
// 매핑이 없는 키는 **원래 키를 그대로** 보여준다. 없는 라벨을 추측해 지어내면
// 로그를 읽는 사람이 엉뚱한 필드를 보고 판단하게 된다.

// 2026-10-13 에 세션 타임존을 KST 로 고정했다(mysql-database.js).
// 그 전에 DEFAULT CURRENT_TIMESTAMP 로 쌓인 AuditLogs.timestamp 는 UTC 라 9시간 빠르다.
// 어느 행이 밀렸는지 확정할 수 없어 백필하지 않았으므로, 이 경계 이전 행에는 표시만 붙인다.
export const UTC_DRIFT_CUTOFF = '2026-10-13';

export const FIELD_LABELS = {
    // 금액·가격
    price: '가격',
    finalPrice: '최종 금액',
    points: '포인트',
    changeAmount: '변동',
    amount: '금액',
    plan_amount: '구독 금액',
    depositAmount: '예약금',

    // 상태·플래그
    status: '상태',
    isActive: '활성',
    includeInStats: '통계 집계',
    is_app_visible: '고객앱 노출',
    use_reservation: '예약 사용',
    is_car_model_required: '차종 필수',
    noChange: '변경 없음',
    created: '신규 생성',

    // 작업
    paymentMethod: '결제수단',
    courseId: '메뉴',
    startTime: '시작',
    endTime: '종료',
    bayNumber: '베이',
    staffId: '담당자',
    memo: '메모',
    comment: '비고',
    reason: '사유',

    // 식별
    menuName: '메뉴명',
    optionName: '옵션명',
    sizeName: '사이즈명',
    modelName: '모델명',
    vehicleClass: '차급',
    shopName: '매장명',
    customerName: '고객명',
    plateNumber: '차량번호',
    owner_name: '닉네임',
    username: '아이디',
    role: '역할',
    type: '유형',

    // 설정
    displayOrder: '표시 순서',
    duration_minutes: '소요 시간(분)',
    bay_count: '베이 수',
    work_start_time: '영업 시작',
    work_end_time: '영업 종료',
    business_number: '사업자번호',
    business_type: '사업 형태',
    default_vehicle_size_id: '기본 사이즈',
    vehicle_size_id: '사이즈',
    carModelId: '차종',
    size_id: '사이즈',
    customer_id: '고객',
    vehicle_id: '차량',
    vehicleId: '차량',

    // 민감 (값은 서버에서 이미 마스킹됨)
    phone: '연락처',
    phoneNumber: '연락처',
    email: '이메일',
    password: '비밀번호',
    passwordChanged: '비밀번호',
};

// 0/1·boolean 로 다루는 필드. '0' 을 그냥 찍으면 금액 0원과 구분이 안 된다.
const BOOL_FIELDS = new Set([
    'isActive', 'includeInStats', 'is_app_visible', 'use_reservation',
    'is_car_model_required', 'isDepositPaid', 'noChange', 'created',
]);

// 불린이지만 '켜짐/꺼짐' 이 아니라 '변경됨' 으로 읽어야 하는 플래그.
// ('비밀번호 변경: 켜짐' 처럼 라벨과 값이 겹쳐 읽히는 걸 피한다)
const CHANGED_FLAG_FIELDS = new Set(['passwordChanged']);

const MONEY_FIELDS = new Set([
    'price', 'finalPrice', 'points', 'changeAmount', 'amount', 'plan_amount', 'depositAmount',
]);

export function renderValue(key, value) {
    if (value === null || value === undefined || value === '') return '(없음)';
    if (CHANGED_FLAG_FIELDS.has(key)) return value ? '변경됨' : '변경 없음';
    if (BOOL_FIELDS.has(key)) {
        if (value === true || value === 1 || value === '1') return '켜짐';
        if (value === false || value === 0 || value === '0') return '꺼짐';
    }
    if (MONEY_FIELDS.has(key)) {
        const n = Number(value);
        if (Number.isFinite(n)) return n.toLocaleString();
    }
    if (typeof value === 'boolean') return value ? '켜짐' : '꺼짐';
    if (typeof value === 'object') return JSON.stringify(value);
    return String(value);
}
